import { DigitizedAsset } from 'editor/src/store/design/types';
import { RootState } from 'editor/src/store/index';

const getDigitizedAssetByUuid = <T extends DigitizedAsset>(state: RootState, elementUuid: number): T | undefined => {
  // Find digitized asset by matching elementUuid in payload
  const assets = state.design.digitizedAssets;

  // Find all assets matching the UUID
  const matchingAssets = Object.values(assets).filter(
    (asset) => asset.payload && 'elementUuid' in asset.payload && asset.payload.elementUuid === elementUuid,
  );

  // Prioritize assets with valid imageIds (non-null)
  const validAsset = matchingAssets.find((asset) => asset.imageId !== null && asset.imageId !== undefined);
  return (validAsset || matchingAssets[0]) as T | undefined;
};

export default getDigitizedAssetByUuid;
